export const URL = "https://20squaredapi.pitans.co.uk/";
// export const URL = "http://127.0.0.1:6001/";
